module.exports = __webpack_public_path__ + "img/kadin.a8254c3f.png";